export default "__VITE_ASSET__UhMS7iFF__"